import React from "react";

function CostEffectiveSvg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
      fill={color}
    >
      <g>
        <ellipse
          cx="256"
          cy="342"
          rx="120"
          ry="50"
          fill={color}
          opacity="1"
          data-original={color}
        ></ellipse>
        <path
          d="M256 482c-35.923 0-70.155-6.021-96.392-16.952-9.389-3.912-17.168-8.188-23.608-12.647V462c0 27.614 53.726 50 120 50s120-22.386 120-50v-9.599c-6.44 4.458-14.219 8.735-23.608 12.647C326.155 475.979 291.923 482 256 482zM256 422c-35.923 0-70.155-6.021-96.392-16.952-9.389-3.912-17.168-8.188-23.608-12.647V402c0 27.614 53.726 50 120 50s120-22.386 120-50v-9.599c-6.44 4.458-14.219 8.735-23.608 12.647C326.155 415.979 291.923 422 256 422zM240.989 262.366c.002-.122.011-.244.011-.366 0-27.614-53.726-50-120-50S1 234.386 1 262c0 26.831 50.723 48.723 114.393 49.944 7.586-11.396 20.974-23.308 44.215-32.992 22.552-9.396 51.018-15.151 81.381-16.586zM1 372.401V382c0 25.498 45.806 46.536 105 49.612v-29.977c-30.367-1.434-58.837-7.189-81.392-16.587C15.219 381.135 7.44 376.859 1 372.401zM106.003 341.635c-30.368-1.434-58.839-7.189-81.394-16.587-9.39-3.913-17.169-8.189-23.609-12.647V322c0 25.498 45.806 46.536 105 49.612V343l.011.006A57.595 57.595 0 0 1 106 342l.003-.365zM196 90h15v75c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15V90h15a14.999 14.999 0 0 0 10.606-25.607l-60-60c-5.857-5.857-15.355-5.857-21.213 0l-60 60A15.001 15.001 0 0 0 196 90zM16 110h15v55c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-55h15a14.999 14.999 0 0 0 10.606-25.607l-60-60c-5.857-5.857-15.355-5.857-21.213 0l-60 60A15.001 15.001 0 0 0 16 110zM376 110h15v55c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-55h15a14.999 14.999 0 0 0 10.606-25.607l-60-60c-5.857-5.857-15.355-5.857-21.213 0l-60 60A15.001 15.001 0 0 0 376 110zM511 262c0-27.614-53.726-50-120-50s-120 22.386-120 50c0 .122.009.244.011.366 30.363 1.435 58.829 7.19 81.38 16.586 23.241 9.684 36.629 21.596 44.215 32.992C460.277 310.723 511 288.831 511 262zM406 401.635v29.977c59.194-3.076 105-24.114 105-49.612v-9.599c-6.44 4.458-14.219 8.735-23.608 12.647-22.555 9.398-51.025 15.153-81.392 16.587zM405.997 341.635 406 342c0 .328-.005.665-.011 1.006L406 343v28.612c59.194-3.076 105-24.114 105-49.612v-9.599c-6.44 4.458-14.219 8.735-23.608 12.647-22.556 9.398-51.026 15.153-81.395 16.587z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
      </g>
    </svg>
  );
}

export default CostEffectiveSvg;
